export default function CTAInstagram() {
  const instagramPosts = [
    'https://readdy.ai/api/search-image?query=BMW%20M3%20with%20carbon%20fiber%20parts%20on%20race%20track%20action%20shot%20with%20motion%20blur%20professional%20automotive%20photography%20for%20social%20media%20post%20motorsport%20content%20simple%20clean%20background&width=600&height=600&seq=insta1&orientation=squarish',
    'https://readdy.ai/api/search-image?query=close%20up%20detail%20of%20glossy%20carbon%20fiber%20weave%20pattern%20texture%20with%20dramatic%20lighting%20professional%20product%20photography%20for%20social%20media%20post%20motorsport%20content%20simple%20clean%20background&width=600&height=600&seq=insta2&orientation=squarish',
    'https://readdy.ai/api/search-image?query=Mercedes%20AMG%20with%20carbon%20fiber%20rear%20wing%20at%20sunset%20golden%20hour%20professional%20automotive%20photography%20for%20social%20media%20post%20motorsport%20content%20simple%20clean%20background&width=600&height=600&seq=insta3&orientation=squarish',
    'https://readdy.ai/api/search-image?query=Porsche%20911%20with%20carbon%20fiber%20aero%20kit%20in%20modern%20garage%20with%20dramatic%20lighting%20professional%20automotive%20photography%20for%20social%20media%20post%20motorsport%20content%20simple%20clean%20background&width=600&height=600&seq=insta4&orientation=squarish',
    'https://readdy.ai/api/search-image?query=Audi%20RS%20with%20carbon%20fiber%20front%20splitter%20detail%20shot%20professional%20automotive%20photography%20for%20social%20media%20post%20motorsport%20content%20simple%20clean%20background&width=600&height=600&seq=insta5&orientation=squarish',
    'https://readdy.ai/api/search-image?query=carbon%20fiber%20manufacturing%20process%20in%20modern%20facility%20professional%20industrial%20photography%20for%20social%20media%20post%20motorsport%20content%20simple%20clean%20background&width=600&height=600&seq=insta6&orientation=squarish'
  ];

  return (
    <section className="bg-white py-16 md:py-32">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-20 items-center">
          {/* Left Content */}
          <div>
            <div className="mb-4 md:mb-6">
              <span className="text-gray-400 text-xs md:text-sm uppercase tracking-[4px] font-bold">
                SOCIAL MEDIA
              </span>
            </div>

            <h2 className="text-black text-4xl sm:text-5xl md:text-7xl font-black tracking-tighter leading-[1.1] mb-6 md:mb-8">
              FOLLOW THE<br />BUILD
            </h2>

            <div className="mb-6 md:mb-10">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center gap-3 text-black text-xl md:text-2xl font-bold hover:text-gray-600 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-2xl md:text-3xl"></i>
                @eaglecarbon
              </a>
              <p className="text-gray-500 text-sm md:text-base mt-2 md:mt-3">
                85,000+ followers
              </p>
            </div>

            <div className="space-y-4 md:space-y-6 mb-8 md:mb-12">
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-camera-line text-black text-lg md:text-xl"></i>
                </div>
                <div>
                  <h3 className="text-black text-base md:text-lg font-bold mb-1">Daily Build Updates</h3>
                  <p className="text-gray-600 text-sm md:text-base">Behind-the-scenes manufacturing and customer installations</p>
                </div>
              </div>

              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-star-line text-black text-lg md:text-xl"></i>
                </div>
                <div>
                  <h3 className="text-black text-base md:text-lg font-bold mb-1">Customer Showcases</h3>
                  <p className="text-gray-600 text-sm md:text-base">Real builds from our community worldwide</p>
                </div>
              </div>

              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-gift-line text-black text-lg md:text-xl"></i>
                </div>
                <div>
                  <h3 className="text-black text-base md:text-lg font-bold mb-1">Exclusive Launches</h3>
                  <p className="text-gray-600 text-sm md:text-base">First access to new products and limited editions</p>
                </div>
              </div>
            </div>

            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center justify-center gap-3 bg-black px-8 md:px-10 py-4 md:py-5 text-white font-bold text-sm md:text-base hover:bg-gray-800 transition-all whitespace-nowrap cursor-pointer w-full sm:w-auto"
            >
              FOLLOW US
              <i className="ri-arrow-right-line text-xl"></i>
            </a>
          </div>

          {/* Right - Instagram Grid */}
          <div className="grid grid-cols-3 gap-2 md:gap-4">
            {instagramPosts.map((post, index) => (
              <a
                key={index}
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="group relative aspect-square overflow-hidden cursor-pointer bg-gray-100"
              >
                <img
                  src={post}
                  alt={`Instagram Post ${index + 1}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <i className="ri-instagram-line text-white text-2xl md:text-4xl"></i>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Bottom Tag Line */}
        <div className="text-center mt-12 md:mt-20 pt-8 md:pt-12 border-t border-gray-200">
          <p className="text-gray-600 text-sm md:text-lg">
            Tag us in your builds with <span className="text-black font-bold">#EagleCarbonBuilds</span> for a chance to be featured
          </p>
        </div>
      </div>
    </section>
  );
}
